<template>
  <div class="help-message">
    <div class="container" v-if="showHelpMessage">
      <p>{{ t("HELP_MESSAGE") }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { useI18n } from "@/apps/merchant3/composables/useI18n";
import { getLanguage } from "@/apps/merchant3/shared-helpers/language.helper";

const store = useStore();
const { t } = useI18n();
const merchantCountry = computed(
  () => store?.state.merchant?.merchant?.country || ""
);

const countryFromCustomerLocaleCode = computed(() => {
  let defaultLanguage = getLanguage();
  let language =
    sessionStorage.getItem("customerLocaleCode") || defaultLanguage;
  return language.substring(3, 5);
});

const showHelpMessage = computed(() => {
  return merchantCountry.value == countryFromCustomerLocaleCode.value;
});
</script>
<style scoped></style>
